import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import PluginParameter from "../../../components/asheetPlugin/plugin-parameters/plugin-parameters";
import { useEffect, useMemo, useRef, useState } from "react";
import serverFunctions from "../../../components/asheetPlugin/utils2/serverFunctions";
import { getUserSheet, userSheetLink } from "../../../services/plugin-sheet.service";
import { toast } from "react-toastify";
import { testData } from "../../../services/test-data.service";
import * as collectionService from '../../../services/data-collection.service';
import * as connectionService from '../../../services/data-source.service';
import moment from "moment-timezone";
import { getClientDateTime } from "../../../shared/code-challanges/code-challanges";
import { AppEnum, FilterParameterNames, ParameterTypeValue, ReservedKeywords } from "../../../constants/app-enum";
import { updateParameterValues } from "../../data-collections/utils/template-collection-parameter";
import { getASTenantId, getRefreshToken, getToken } from "../../../shared/local-storage-handler/local-storage-handler";
import { CircularProgress } from "@mui/material";
import _ from "lodash";
import { getPluginChange } from "../../../services/authCallback-service";
import { MergeTestData } from "../../../services/merge-collection-test-data-service";
import { getAllScript } from "../../../services/data-script.service";
import { updateParameterValues as cloudUpdateParameterValues } from "../../data-collections/utils/template-collection-parameter";
import { useSelector } from "react-redux";
import { filterCollectionParams } from "../../data-collections/DataVisualizer/data-visualizer-controller";

const PluginParameterController = () => {
    const userName = useSelector((state) => state.pluginState?.userName);
    const { collectionUId: collectionUId } = useParams();
    const [state, setState] = useState();
    const [data, setData] = useState();
    const [selectedCollection, setSelectedCollection] = useState();
    const [isLoader, setIsLoader] = useState();
    const location = useLocation();
    const navigate = useNavigate();
    const [testDataCollectionResult, setTestDataCollectionResult] = useState();
    const [activeSheetDetails, setActiveSheetDetails] = useState();
    const regexDateTImeFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
    const [activeSheetName, setActiveSheetName] = useState("");
    const [isSheetLinked, setIsSheetLinked] = useState(null);
    const activeSheet = useRef({});
    const [openedIFrame, setOpenedIFrame] = useState(false);
    const parameterTypes = Object.values(ParameterTypeValue());
    const parameterNames = Object.values(ReservedKeywords());
    const [mergedCollectionsData, setMergedCollectionsData] = useState([])
    const [filterConfig, setFilterConfig] = useState({
        numberOfFilterGroupAllowed: 0,
        numberOfFilterPerGroupAllowed: 0,
        numberOfSortAllowed: 0,
        operatorAllowedInFilterGroup: [],
        operatorAllowedInFilter: [],
        filterTypeArray: [],
        filterGroupExceeded: "",
        filterPerGroupExceeded: "",
        SortExceeded: ""
    });
    const [isMergeDataPopupVisible, setIsMergeDataPopupVisible] = useState(false);
    const [mergeDataPopupMessage, setMergeDataPopupMessage] = useState([]);
    const [preDefinedScriptsData, setPreDefinedScriptsData] = useState();
    const isMergeCancelledRef = useRef(false);
    const stateRef = useRef();
    const [hasExecuted, setHasExecuted] = useState(false)
    const [isAppend, setIsAppend] = useState(false)
    const urlParams = new URLSearchParams(window.location.search);

    useEffect(async () => {
        setSelectedCollection(location.state)
        await getCollectionDetails();
        await getUserSheetData();

    }, [])

    const handleBack = () => {
        navigate("/plugin", {
            state: selectedCollection
        })
    }

    const updateAPI = async (userSheetModel) => {

        try {
            const response = await userSheetLink(userSheetModel);
            if (response?.hasError) {
                toast.error(response?.errorMessage);
            }
            else {
                setIsSheetLinked(userSheetModel?.isLinked);
            }
        } catch (error) {

        } finally {
            // setIsLoader(false);
        }
    }

    useEffect(() => {

        const updateSheetData = async () => {

            try {
                // let parameterObject = await extractParameterObject();

                let model = {
                    lastUserRenderedBy: state.createdBy,
                    collectionUId: collectionUId,
                    documentLink: activeSheetDetails?.sheetInfo?.activeSheetUrl,
                    sheetId: activeSheetDetails?.sheetInfo?.activeSheetId,
                    sheetName: activeSheetDetails?.sheetInfo?.name,
                    isLinked: testDataCollectionResult?.errorMessage == null ? true : activeSheet.current.isLinked,
                    isRemoved: false,
                    parameterValues: state.collectionParameters ?? null,
                    dataRenderRange: testDataCollectionResult?.errorMessage ? null : activeSheetDetails?.sheetInfo?.dataRange,
                    noOfRawRows: testDataCollectionResult?.recordRows,
                    noOfFinalRows: testDataCollectionResult?.errorMessage ? null : activeSheetDetails?.sheetInfo?.noOfRows,
                    bytes: testDataCollectionResult?.dataSize,
                    lastRenderWasSuccessful: testDataCollectionResult?.errorMessage == null ? true : false,
                    lastErrorMessage: testDataCollectionResult?.errorMessage,
                };

                if (!activeSheetDetails?.success && testDataCollectionResult?.errorMessage == null) {
                    model.lastErrorMessage = activeSheetDetails?.message;
                    model.lastErrorTrace = activeSheetDetails?.stack;
                    model.lastRenderWasSuccessful = false;
                    model.isLinked = false;
                }

                await updateAPI(model);
                getUserSheetData();
            } catch (error) {
                console.error('Error updating sheet data:', error);
            }
        };

        if (testDataCollectionResult?.errorMessage || (testDataCollectionResult && activeSheetDetails)) {
            updateSheetData();
        }
    }, [testDataCollectionResult, activeSheetDetails]);

    const executeData = async (state) => {
        stateRef.current.isCreateTemplate = state?.isCreateTemplate
        setIsLoader(true)
        try {
            let testDataCollectionModal = {
                connectionUId: state.connectionUId,
                connectionId: state?.connection?.id,
                sysCollectionTypeId: state.sysCollectionTypeId,
                sourceName: state.sourceName,
                restRequestMethod: state.restRequestMethod,
                restRequestIsAsync: true,
                restSendAsCD: state.restSendAsCD,
                collectionParameters: state.collectionParameters,
                collectionColumns: state?.collectionColumns,
                uId: state.uId,
                returnFlatternData: state?.sysCollectionTypeId === AppEnum?.SysCollectionTypeId?.SQL_SERVER ? false : !(state.returnRawData),
                sourceNamePart4: state.sourceNamePart4,
                templateCollectionId: state.templateCollectionId,
                collectionFilters: getFilterModal('filter'),
                collectionSorts: getFilterModal('sort'),
                collectionLimit: getFilterModal('limit'),
                restDataTransformationScript: state?.restDataTransformationScript,
                returnRawData: state.returnRawData,
                restBody: selectedCollection?.restBody ?? null,
                savedParameterValue: state?.savedParameterValue,
                excludedProperties: state?.excludedProperties ?? '',
                flattenLikeSql: state?.flattenLikeSql ?? false,
                combineMergedParameters: state.combineMergedParameters ?? false,
                mergeScript: state.mergeScript ?? '',
                selectedScriptType: state.selectedScriptType,
                dataStylingScript: state?.dataStylingScript,
                dataStylingScriptId: state?.dataStylingScriptId,
                dataTransformationScriptId: state?.dataTransformationScriptId,
                hasMergeCollections: state?.hasMergeCollections,
                collectionUIdsToMerge: state?.collectionUIdsToMerge,
                columnApiEndpoint: state?.columnApiEndpoint ?? '',
            };

            if (testDataCollectionModal.hasMergeCollections &&
                Array.isArray(testDataCollectionModal.collectionUIdsToMerge)) {

                let preDefinedScripts = preDefinedScriptsData;
                if (!preDefinedScriptsData?.length) {
                    const scriptsResponse = await getAllScript();
                    preDefinedScripts = scriptsResponse?.data;
                    setPreDefinedScriptsData(preDefinedScripts);
                }

                const response = await MergeTestData(
                    testDataCollectionModal,
                    setState,
                    null,
                    setIsMergeDataPopupVisible,
                    setMergedCollectionsData,
                    setMergeDataPopupMessage,
                    null,
                    isMergeCancelledRef,
                    setIsLoader,
                    preDefinedScripts,
                    true,
                    true

                );

                setTestDataCollectionResult(response);
                setDataToSheet(response?.data?.data)
                if (response?.errorMessage === null) {
                    setDataToSheet(response)
                    if (typeof activeSheet.current === 'object' && activeSheet.current !== null) {
                        activeSheet.current.lastRenderSuccessfulDateTime = null;
                    }
                }
            } else {
                var testDataResult = await testData(
                    testDataCollectionModal,
                    setData,
                    setDataToSheet,
                    null,
                    true,
                    setState,
                    setIsLoader,
                    true,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    true
                );
                let response = testDataResult?.hasError ? testDataResult : testDataResult?.data;
                setTestDataCollectionResult(response);
            }
        } catch (error) {
            console.error("Error executing data:", error);
            toast.error("Error executing data: " + error.message);
        }
    };

    let isRunning = false;

    const fetchData = async () => {

        if (isRunning) return;

        // Set the flag to true indicating an execution is in progress
        isRunning = true;
        const sheetChanges = await serverFunctions?.getSheetChange();
        try {

            if (sheetChanges?.sheetChange !== "null") {
                const sheetChange = JSON.parse(sheetChanges?.sheetChange);
                // stateRef.current.name = sheetChange.name
                await checkChanges(sheetChange)
            }
        } catch {

        } finally {
            isRunning = false;
        }

    }

    useEffect(() => {
        const intervalId = setInterval(async () => {

            await fetchData();

        }, 3000); // Poll every 1 seconds

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, []);

    const checkChanges = async (sheetChange) => {
        try {
            if (activeSheet.current?.sheetId === sheetChange?.id) {
                setActiveSheetName(sheetChange?.name);
            }
            const response = await getUserSheet(sheetChange?.collectionUId.toString())
            if (response?.data !== "") {
                const userSheetModel = response?.data;
                if (sheetChange?.changeType === "Rename") {
                    userSheetModel["sheetName"] = sheetChange?.name;
                    await updateAPI(userSheetModel);
                }
                else if (sheetChange?.changeType === "Remove") {

                    userSheetModel["isLinked"] = false;
                    // userSheetModel["sheetId"] = null;
                    await updateAPI(userSheetModel);
                    // userSheetData();
                    if (activeSheet.current?.collectionUId === sheetChange?.collectionUId) {
                        setIsSheetLinked(false);
                        setActiveSheetName("");
                    }
                }
            }

        } catch (error) {
            toast.error(error);
        }
    }

    const getUserSheetData = async () => {
        try {
            const response = await getUserSheet(collectionUId);
            const sheetIds = await serverFunctions.getSheetsIds();
            if (response?.hasError) {
                setIsSheetLinked(false)
            }
            else {
                if (response?.data?.isLinked) {
                    let sheetExists = sheetIds?.some(item => item?.sheetId == response?.data?.sheetId);
                    if (!sheetExists) {
                        const userSheetModel = {
                            ...response.data,
                            isLinked: false,
                            sheetId: null
                        };
                        await updateAPI(userSheetModel);
                    }
                    else {
                        let collectionParameters = JSON.parse(response?.data?.parameterValues);
                        let searchParameters = [];
                        collectionParameters?.map((parameter) => {
                            if (parameterTypes.includes(parameter.parameterTypeCD) && parameter.parameterTypeCD !== 'Fixed Hidden' && parameter.parameterTypeCD !== "") {

                                searchParameters.push(parameter);
                            }
                        })
                        setState((prevState) => ({
                            ...prevState,
                            searchParameters: searchParameters,
                            collectionParameters: collectionParameters
                        }));
                        stateRef.current = {
                            ...state,
                            searchParameters: searchParameters,
                            collectionParameters: collectionParameters
                        }


                        setActiveSheetName(response?.data?.sheetName);
                        activeSheet.current = response?.data;
                    }
                    setIsSheetLinked(sheetExists);
                }
                else {
                    setIsSheetLinked(false);
                }

            }

        } catch (error) {
            toast.error(error);
        }
    }
    const getMergedCollectionsParameters = async (collectionUIdsToMerge, combineMergedParameters) => {
        try {
            const response = await collectionService.getMergeCollectionParameters(collectionUIdsToMerge);
            if (response?.hasError) {
                return [];
            }
            if (response?.data) {
                let result = response.data;
                if (combineMergedParameters) {
                    result = _.uniqBy(response?.data,
                        item => `${item.parameterTypeCD}_${item.parameterName}_${item.sysDataTypeId}`);
                } else {
                    result = response?.data;
                    let updatedParams = [];
                    for (const collectionUId of collectionUIdsToMerge) {
                        const collectionResult = await collectionService.getCollectionDetails(collectionUId, true);
                        const collectionDetails = collectionResult?.data;

                        let collParams = result?.filter(i => i.childCollectionUId == collectionUId);
                        let updatedCollParams = collParams;

                        if (collectionDetails?.templateCollectionId) {
                            updatedCollParams = await cloudUpdateParameterValues(collParams, collectionDetails?.savedParameterValue, state);
                        } else {
                            updatedCollParams = updateParameterValues(collParams);
                        }

                        updatedParams.push(...updatedCollParams);
                    }
                    result = updatedParams;
                }

                result?.forEach((params) => {
                    if (params?.sysDataTypeId == (AppEnum.DataTypeId.DynamicList || AppEnum.DataTypeId.List)
                        && params?.childComplexTypeValue) {
                        params.complexTypeValue = params?.childComplexTypeValue;
                    }
                });
                return result;
            }
            return [];
        } catch (error) {
            console.error("Error fetching merged collection parameters:", error);
            return [];
        }
    };


    const getCollectionDetails = async (collectionParameters) => {
        const data = await collectionService.getCollectionDetails(collectionUId);
        const state = data?.data
        setSelectedCollection(state)
        let searchParameters = [];
        let filterSortParameters = [];
        if (state?.collectionParameters?.length) {
            if (collectionParameters?.length)
                state.collectionParameters = collectionParameters
            state.collectionParameters = _.orderBy(state.collectionParameters, ['displayOrder', 'id'], ['asc', 'asc'])

        }

        if (state.hasMergeCollections) {
            const response = await getMergedCollectionsParameters(state.collectionUIdsToMerge, state?.combineMergedParameters);
            state["collectionParameters"] = response;
        }

        let updatedParams = (state.hasMergeCollections || collectionParameters?.length) ? state.collectionParameters : updateParameterValues(state.collectionParameters, state?.savedParameterValue)

        updatedParams.forEach((parameter) => {

            if (parameterTypes.includes(parameter.parameterTypeCD) && parameter.parameterTypeCD !== 'Fixed Hidden' && parameter.parameterTypeCD !== '') {
                searchParameters.push(parameter)
                state.searchParameters = searchParameters
            }
            else if (parameterNames.includes(parameter.parameterName)) {
                filterSortParameters.push(parameter)
                state.filterSortParameters = filterSortParameters
            }
        })

        if (state.hasMergeCollections) {
            await fetchAndProcessMergeCollectionDetails(state, true, false, setState)
        }
        setState((prevState) => ({
            ...prevState,
            ...state
        }));

        stateRef.current = (state)
        return state
    }

    useEffect(() => {
        setSelectedCollection(location.state)

    }, [])

    const createSheetAndAddData = async (header, data, sheetName, sheetId, collectionUId, connectionName) => {
        if (data === null || !data.length) {
            toast.error("No Data");
            setIsLoader(false);
            return;
        }
        const isRenderInSameSheet = urlParams.get('isExecuteData') ?? null
        const collectionParameterInfo = extractCollectioParameterObject(state, header)

        let response = await serverFunctions.sendDataToSheet(header, data, sheetName, sheetId, collectionUId, connectionName, isRenderInSameSheet, collectionParameterInfo, false, isAppend, state?.isCreateTemplate);


        setActiveSheetDetails(response);
        setActiveSheetName(response?.sheetInfo?.name);

    };

    const getFilterModal = (filterLable, data) => {
        const state = stateRef.current;

        if (state?.collectionParameters.length > 0) {
            var filterParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.filter);
            var sortParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.sort);
            var limitParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.limit);
            if (filterParameter && filterParameter?.length > 0 && filterLable === "filter") {
                var filter = JSON.parse(filterParameter[0].defaultValue);
                return getFilterData(filter)
            }
            if (sortParameter && sortParameter?.length > 0 && filterLable === "sort") {
                var sort = JSON.parse(sortParameter[0].defaultValue);
                return sort
            }
            if (limitParameter && limitParameter?.length > 0 && filterLable === "limit") {
                var limit = JSON.parse(limitParameter[0].defaultValue);
                return limit
            }
        }
    }

    const getFilterData = (filterData) => {
        const filterGroups = filterData?.map(group => {
            const filters = group?.filters.map(item => ({
                field: item.field,
                value: item.value,
                operator: item.operator,
                condition: item.condition,
                displayName: item.displayName,
                highValue: item.highValue,
                values: item.values,
                dateLabel: item.dateLabel,
                dataTypeName: item.dataTypeName,
                valueLabel: item.valueLabel,
                dateLabelValue: item.dateLabelValue,
                conditionLabel: item.conditionLabel,
            }));
            return { filters: filters, operator: group?.operator };
        });

        if (!filterGroups || filterGroups.length === 0) {
            return [];
        }
        return [{ filterGroups: filterGroups }];
    };

    const setDataToSheet = async (data, dynamicColumns) => {
        if (data === null || !data?.length) {
            toast.error("No Data");
            setIsLoader(false);
            return;
        }
        const state = stateRef.current
        let header;
        if (dynamicColumns && dynamicColumns?.length) {
            header = dynamicColumns?.sort((a, b) => a.displayOrder - b.displayOrder);
        } else {
            header = state?.collectionColumns?.sort((a, b) => a.displayOrder - b.displayOrder);
        }


        const validKeys = header?.map(item => item.columnName);

        const rowData = Array.isArray(data) ? data : [...data];

        const filteredRowData = rowData.map((item) => {
            const filteredItem = Object.keys(item).reduce((acc, key) => {
                if (validKeys.includes(key)) {
                    acc[key] = item[key];
                }
                return acc;
            }, {});

            for (const [key, value] of Object.entries(filteredItem)) {
                if (regexDateTImeFormat.test(`${value}`)) {
                    filteredItem[key] = convertToDateFormat(`${value}`);
                }
            }
            return filteredItem;
        });
        const sheetName = activeSheetName ? activeSheetName : `AS_${state?.name}`
        const jsonData = JSON.stringify(filteredRowData)

        await createSheetAndAddData(header, jsonData, sheetName, activeSheet.current?.sheetId, state?.uId, state?.connectionName)

        setIsLoader(false);

    }

    const extractParameterObject = () => {
        const collectionParameters = state?.collectionParameters.map(i => ({
            Id: i.id,
            CollectionId: i.collectionId,
            ParameterValue: i.parameterValue,
            ChildCollectionUId: i.childCollectionUId
        }));
        return collectionParameters;
    }
    const extractCollectioParameterObject = (state, collectionColumns) => {

        const handleSavingCloudParams = (searchOptionsParameters) => {
            let paramsToSave = searchOptionsParameters?.filter(i => i.enableSavingParameterValue);
            if (paramsToSave?.length > 0) {
                const result = paramsToSave.map(param => ({
                    Id: param.id,
                    Value: param.parameterValue,
                }));
                return JSON.stringify(result);
            }
        }
        const savedParameterValue = handleSavingCloudParams(state?.searchParameters);

        const data = {
            "connectionUId": state.connectionUId,
            "groupName": state.groupName,
            "childGroupName": state.childGroupName,
            "sourceName": state.sourceName,
            "name": state.name,
            "templateCollectionId": state.templateCollectionId,
            "dataTransformationScriptId": state.dataTransformationScriptId,
            "dataStylingScriptId": state.dataStylingScriptId,
            "restDataTransformationScript": state.restDataTransformationScript,
            "dataStylingScript": state.dataStylingScript,
            "savedParameterValue": savedParameterValue,
            "collectionParameters": state.filterSortParameters,
            "collectionColumns": collectionColumns,
            "connectionName": state.connectionName,
            'userName': userName
        }
        return data
    }

    const convertToDateFormat = (timestamp) => {
        const date = new Date(timestamp);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedDate;
    }



    const handleRunOrRefresh = async (state) => {
        const updatedState = stateRef.current;

        if (isSheetLinked) stateRef.current = updatedState;

        executeData(updatedState);
    };

    useEffect(() => {
        if (selectedCollection?.sysConnectionTypeId) {
            getCollectionFilterConfig(selectedCollection?.sysConnectionTypeId);
        }
    }, [selectedCollection])

    const getCollectionFilterConfig = (connectionTypeId) => {
        collectionService.getCollectionFilterConfig(connectionTypeId)
            .then((response) => {
                if (response?.data) {

                    setFilterConfig({
                        numberOfFilterGroupAllowed: response.data?.numberOfFilterGroupAllowed,
                        numberOfFilterPerGroupAllowed: response.data?.numberOfFilterPerGroupAllowed,
                        numberOfSortAllowed: response.data?.numberOfSortAllowed,
                        operatorAllowedInFilterGroup: response.data?.operatorAllowedInFilterGroup,
                        operatorAllowedInFilter: response.data?.operatorAllowedInFilter,
                        filterTypeArray: response.data?.filterTypeArray,
                        filterGroupExceeded: response.data?.filterGroupExceeded,
                        filterPerGroupExceeded: response.data?.filterPerGroupExceeded,
                        SortExceeded: response.data?.sortExceeded
                    });
                }
            })
    }

    const openDataVisualizer = async () => {
        const parameters = extractParameterObject();
        const params = {
            collectionUId: collectionUId,
            token: getToken(),
            refreshToken: getRefreshToken(),
            asTenantUid: getASTenantId(),
            parameters: JSON.stringify(parameters)
        }

        let nativeCollection = (state?.templateCollectionId == null);

        var url = `collection/${nativeCollection ? "native-" : ""}data-visualizer?collectionUId=${params?.collectionUId}
                                    &AccessToken=${params?.token}&RefreshToken=${params?.refreshToken}
                                    &ASTenantUId=${params?.asTenantUid}
                                    &Parameters=${params?.parameters}
                                    &isGoogleDriveFromExcel=${true}
                                    &isNativeVisualizer=${false}
                                    &closeWindowOnPopupClose=${true}`;
        url = url.replace(/\s+/g, '');
        url = encodeURI(url);
        setOpenedIFrame(true)
        await serverFunctions.openDialog(url).then().catch(alert);
    };

    useEffect(() => {
        stateRef.current = state

    }, [state])

    const openAddNewConnectionDialog = async () => {
        const params = {
            connectionUId: selectedCollection?.connection?.uId,
            token: getToken(),
            refreshToken: getRefreshToken(),
            asTenantUid: getASTenantId()
        }
        const url = `data-collections/add-new-data-collection?connectionUId=${params?.connectionUId}&AccessToken=${params?.token}&RefreshToken=${params?.refreshToken}&ASTenantUId=${params?.asTenantUid}&closeWindowOnPopupClose=true`

        await serverFunctions.openDialog(url).then().catch(alert);
    }

    const getSheetChanges = async () => {
        const sheetChanges = await getPluginChange(collectionUId);
        if (sheetChanges?.data === "stopPolling") {
            setOpenedIFrame(false)
        }
        if (sheetChanges?.data) {
            const parameters = JSON.parse(sheetChanges?.data)
            setOpenedIFrame(false)
            setIsLoader(true)
            const state = await getCollectionDetails(parameters)
            stateRef.current = state
            await executeData(stateRef.current)

        }

    }

    useEffect(() => {
        if (openedIFrame) {
            const intervalId = setInterval(async () => {
                await getSheetChanges();
            }, 1500);
            return () => clearInterval(intervalId);
        }
    }, [openedIFrame]);

    const getMergedCollectionDetails = () => {
        collectionService.getAllCollections()
            .then((response) => {
                if (response?.hasError) {
                    setState((prevState) => ({
                        ...prevState,
                        errorMessage: response?.errorMessage
                    }));
                } else if (response?.data) {
                    const usedCollections = response.data
                        .filter(item => state?.collectionUIdsToMerge.includes(item.uId))
                        .map(item => ({
                            ...item,
                            isConnectionAuthorize: true
                        }));
                    setMergedCollectionsData(usedCollections);
                }
            });
    };

    useEffect(() => {
        if (state?.hasMergeCollections &&
            state?.collectionUIdsToMerge &&
            mergedCollectionsData?.length === 0) {
            getMergedCollectionDetails();
        }
    }, [state?.hasMergeCollections, state?.collectionUIdsToMerge]);

    useEffect(() => {
        if (state?.hasMergeCollections) {
            if (state.restBody) {
                setState((prevState) => { return { ...prevState, selectedScriptType: AppEnum.MergeCollection.SQL } })
            }
            else if (state.mergeScript) {
                setState((prevState) => { return { ...prevState, selectedScriptType: AppEnum.MergeCollection.Custom_Script } })
            }
            else if (state.dataTransformationScriptId) {
                setState((prevState) => { return { ...prevState, selectedScriptType: AppEnum.MergeCollection.Predefined_Script } })
            }
        }
    }, [state?.hasMergeCollections, state?.hasMergeCollections, state?.mergeScript, state?.dataTransformationScriptId]);


    const handleMergePopupClose = () => {
        setIsMergeDataPopupVisible(false);
        setMergeDataPopupMessage([]);
    }


    const fetchAndProcessMergeCollectionDetails = async (
        testDataCollectionModal,
        executeWithParameters,
        isExecutingSearchOptionsForMergeCollections,
        setCollectionState
    ) => {
        const allCollectionDetailsResults = {};
        const mergeParamsCallingCollectionUId = {};
        const mergeCollectionsSavedParamValues = {};
        const globalExecuteWithParameters = executeWithParameters;

        // Step 1: Fetch collection details
        for (const collectionUId of testDataCollectionModal?.collectionUIdsToMerge) {
            const response = await collectionService.getCollectionDetails(collectionUId, true);
            const collection = response?.data;
            executeWithParameters = globalExecuteWithParameters;

            let templateCollectionDetails = null;

            if (collection?.templateCollectionId) {
                templateCollectionDetails = await collectionService.getTemplateCollectionDetails(collection.templateCollectionId);
            }
            collection.connectionId = collection?.connection?.id;

            collection.returnFlatternData = collection?.sysCollectionTypeId === AppEnum?.SysCollectionTypeId?.REST
                ? !(collection?.returnRawData)
                : collection?.templateCollectionId !== null
                    ? !(templateCollectionDetails?.data?.returnRawData)
                    : false;

            if (collection?.templateCollectionId) {
                executeWithParameters = true;

                if (collection?.savedParameterValue) {
                    mergeCollectionsSavedParamValues[collection?.uId] = collection?.savedParameterValue;
                }
            }

            if (executeWithParameters && !isExecutingSearchOptionsForMergeCollections) {
                collection.collectionParameters = updateParameterValues(collection?.collectionParameters, collection?.savedParameterValue);
            }

            if (executeWithParameters) {
                collection?.collectionParameters.forEach((parameter) => {
                    if (testDataCollectionModal?.combineMergedParameters) {
                        const matchingParam = testDataCollectionModal?.collectionParameters.find(
                            (param) =>
                                param.parameterName === parameter.parameterName &&
                                param.displayName === parameter.displayName &&
                                param.sysDataTypeId === parameter.sysDataTypeId
                        );

                        if (matchingParam) {
                            parameter.defaultValue = matchingParam.defaultValue;
                            parameter.parameterValue = matchingParam.parameterValue;
                        }
                    }
                    else {
                        if (isExecutingSearchOptionsForMergeCollections) {
                            let paramValue = testDataCollectionModal?.collectionParameters.find(
                                i => i.collectionParameterId == parameter.id &&
                                    i.childCollectionUId == collectionUId
                            )?.parameterValue;
                            parameter.parameterValue = paramValue;
                        }
                    }
                });
            }

            allCollectionDetailsResults[collection?.name] = collection;

            collection?.collectionParameters?.forEach((params) => {
                if (params?.sysDataTypeId == AppEnum.DataTypeId.DynamicList) {
                    let paramName = params.parameterName;
                    let childCollectionUId = collection?.uId;
                    let childConnectionUId = collection?.connectionUId;
                    mergeParamsCallingCollectionUId[paramName + childCollectionUId] = childConnectionUId;
                }
            });
        }
        setCollectionState((prevState) => {
            return { ...prevState, mergeParamsCallingCollectionUId: mergeParamsCallingCollectionUId, mergeCollectionsSavedParamValues: mergeCollectionsSavedParamValues }
        })
    }

    useEffect(() => {
        const isExecuteData = urlParams.get('isExecuteData')
        if (isExecuteData == "true" && state && !hasExecuted) {
            setHasExecuted(true)
            if (state?.collectionParameters?.length) {
                executeData(state);
            }
        }
    }, [state])

    return (
        <>
            {
                isSheetLinked === null ?
                    <CircularProgress
                        className={`circularLoader`}
                        thickness={4}
                        size={50}
                    /> :
                    <PluginParameter
                        handleBack={handleBack}
                        selectedCollection={selectedCollection}
                        state={state}
                        setState={setState}
                        isOpen={isLoader}
                        isLinked={isSheetLinked}
                        activeSheetName={activeSheetName}
                        activeSheet={activeSheet}
                        handleRunOrRefresh={handleRunOrRefresh}
                        filterConfig={filterConfig}
                        openDataVisualizer={openDataVisualizer}
                        openAddNewConnectionDialog={openAddNewConnectionDialog}
                        mergedCollectionsData={mergedCollectionsData}
                        isMergeDataPopupVisible={isMergeDataPopupVisible}
                        mergeDataPopupMessage={mergeDataPopupMessage}
                        handleMergePopupClose={handleMergePopupClose}
                        isMergeCancelledRef={isMergeCancelledRef}
                        isAppend={isAppend}
                        setIsAppend={setIsAppend}
                        executeData={executeData}
                    />}
        </>
    )
}

export default PluginParameterController;